import { render, staticRenderFns } from "./ElementActions.vue?vue&type=template&id=bc024c8c&"
import script from "./ElementActions.vue?vue&type=script&lang=js&"
export * from "./ElementActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports